import useToastManager from "@/composables/toastManager.js"
import i18n from "@/locales/index.js"

const inviteSuccessfullyAcepted = () => {
  useToastManager().success({
    message: i18n.global.t("component.notification.invitation.accept.ok")
  })
}

export { inviteSuccessfullyAcepted }
